import {Injectable} from '@angular/core';
import {Constant} from '../../global/util/Constant';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Person} from '../model/Person';
import {Headers} from '../../global/util/Headers';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PublicService {
  private url = Constant.ROOT_API_V1.concat('/public/');

  constructor(private http: HttpClient) {
  }

  getCountries(): Observable<any> {
    return this.http.get(this.url.concat('countries'));
  }

  getDocumentIdentifications(): Observable<any> {
    return this.http.get(this.url.concat('identificationdocuments'));
  }

  getEnterpriseCustomLink(hashCode: string): Observable<any> {
    return this.http.get(this.url.concat('verify/').concat(hashCode).concat('/enterprise'));
  }

  save(person: Person): Observable<any> {
    return this.http.post(this.url.concat('people'), JSON.stringify(person), Headers.contentType);
  }

  getJobs(enterpriseId: number) {
    return this.http.get(this.url.concat('enterprises/').concat(String(enterpriseId)).concat('/jobs'));
  }

  validate(formData: FormData): Observable<any> {
    return this.http.post(this.url.concat('documents/validator'), formData);
  }

  get(urlSearch: string): Observable<any> {
    return this.http.get(urlSearch);
  }

  verifyHavePermission(url: string): Observable<any> {
    return this.http.get<any>(url);
  }

  verifyTimeToDownload(url: string): Observable<any> {
    return this.http.get<any>(url);
  }

  download(urlStream: string, filename: string): Observable<any> {
    return this.http.get(urlStream, {observe: 'response', responseType: 'blob'}).pipe(map(response => {
      if (response && response.headers) {
        const control = document.createElement('a');
        control.setAttribute('style', 'display:none;');
        document.body.appendChild(control);
        control.href = window.URL.createObjectURL(response.body);
        control.download = filename;
        control.click();
      }
    }));
  }

  verifyAcceptTerm(uanatacaRequestId: number): Observable<any> {
    return this.http.get(this.url.concat('accept-term-condition/').concat(String(uanatacaRequestId).concat('/')));
  }

  register(uanatacaRequestId: number): Observable<any> {
    const formData = new FormData();
    formData.append('uanatacaRequestId', String(uanatacaRequestId));
    return this.http.post(this.url.concat('accept-term-condition/save'), formData);
  }
}
